"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conditions = void 0;
const async_ray_1 = require("async-ray");
const lodash_get_1 = __importDefault(require("lodash.get"));
const shared_types_1 = require("@sigmasms/shared-types");
const utils_1 = require("./utils");
const check_functions_1 = require("./check-functions");
class Conditions {
    static getTag(tag) {
        if (!_a.allTags[tag]) {
            throw new Error(`Path '${tag}' not supported.`);
        }
        return _a.allTags[tag];
    }
    /**
     * Проверяет массив условий сразу
     * Метод всегда асинхронный, работает с async-ray
     */
    static checkMultipleConditions(testingValue_1) {
        return __awaiter(this, arguments, void 0, function* (testingValue, conditions = []) {
            const uniqueConditions = conditions.filter((rule, index, rules) => {
                return rules.findIndex(({ tag }) => rule.tag === tag) === index;
            });
            return yield (0, async_ray_1.AsyncRay)(uniqueConditions).aEvery((rule) => __awaiter(this, void 0, void 0, function* () { return yield _a.checkSingleCondition(testingValue, rule); }));
        });
    }
    /**
     * Функция сравнения одного правила
     * В ответе может быть как boolean так и Promise<boolean>,
     * в зависимости от реализации метода checkInContactLists
     * По умолчанию отрабатывает синхронно
     */
    static checkSingleCondition(testingValue, condition) {
        return __awaiter(this, void 0, void 0, function* () {
            const { tag, value } = _a.standardizeCondition(condition);
            const { path, check } = _a.tags[tag];
            const targetValue = (0, lodash_get_1.default)(testingValue, path);
            return check(targetValue, value);
        });
    }
    /**
     * Приводит объект Conditions к стандартному виду
     */
    static standardizeCondition(anyConditionsObject) {
        var _b;
        const { path, type, tag, value } = anyConditionsObject;
        const computedTag = (_b = tag !== null && tag !== void 0 ? tag : path) !== null && _b !== void 0 ? _b : type;
        if (!computedTag) {
            throw new Error('Tag not found in conditions object');
        }
        const tagMeta = _a.getTag(computedTag);
        return {
            tag: tagMeta.tag,
            value: tagMeta.standardize ? tagMeta.standardize(value) : value
        };
    }
    /**
     * Фильтрует массив ConditionsObjectBackwardsCompatibility, убирает дубли и возвращает массив ConditionsObject
     */
    static filterConditionsArray(conditionsArray = []) {
        const result = [];
        if (Array.isArray(conditionsArray) && conditionsArray.length) {
            for (const condition of conditionsArray) {
                if (typeof condition === 'object' && condition) {
                    const standardizedCondition = _a.standardizeCondition(condition);
                    if (result.find(({ tag }) => standardizedCondition.tag === tag)) {
                        continue;
                    }
                    const { validateValue } = _a.tags[standardizedCondition.tag];
                    if (validateValue(standardizedCondition.value)) {
                        result.push(standardizedCondition);
                    }
                }
            }
        }
        return result;
    }
    /**
     * Возвращает схему для валидации в легаси
     */
    static get fastestValidatorSchema() {
        return {
            type: 'one-of',
            rules: Object.keys(_a.tags).map(tag => {
                return {
                    type: 'object',
                    props: {
                        tag: {
                            type: 'string',
                            enum: [_a.allTags[tag].tag, _a.allTags[tag].path]
                        },
                        value: _a.allTags[tag].fastestValidatorSchema
                    }
                };
            })
        };
    }
    static setCheckFunctions(checkFunctionClass) {
        _a.checkFunctions = checkFunctionClass;
    }
    /**
     * @deprecated Используйте fastestValidatorRules
     */
    static get validatorRules() {
        return _a.fastestValidatorSchema;
    }
    /**
     * @deprecated Используйте `Object.keys(Conditions.tags)`
     */
    static get tagsOnly() {
        return Object.keys(_a.tags);
    }
    /**
     * @deprecated Используйте checkSingleCondition
     */
    static check(originalCondition, testingValue) {
        return __awaiter(this, void 0, void 0, function* () {
            return _a.checkSingleCondition(testingValue, originalCondition);
        });
    }
}
exports.Conditions = Conditions;
_a = Conditions;
Conditions.checkFunctions = check_functions_1.ConditionsCheckFunctions;
Conditions.tags = {
    /**
     * Сравниваем `sender1` с `[ 'sender1', 'sender2' ]
     */
    [shared_types_1.EConditionsTags.sender]: {
        tag: shared_types_1.EConditionsTags.sender,
        path: 'payload.sender',
        fastestValidatorSchema: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        standardize: utils_1.convertListRegexpToArray,
        check: _a.checkFunctions.checkStringArray,
        validateValue: utils_1.isArrayOfStringNotEmpty
    },
    /**
     * Сравниваем `sms` с `[ 'sms', 'viber' ]`
     */
    [shared_types_1.EConditionsTags.type]: {
        tag: shared_types_1.EConditionsTags.type,
        path: 'type',
        fastestValidatorSchema: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        standardize: utils_1.convertListRegexpToArray,
        check: _a.checkFunctions.checkStringArray,
        validateValue: utils_1.isArrayOfStringNotEmpty
    },
    /**
     * Сравниваем 'megafon' с `[ 'mts', 'megafon' ]`
     */
    [shared_types_1.EConditionsTags.group]: {
        tag: shared_types_1.EConditionsTags.group,
        path: 'meta._recipientData.group',
        fastestValidatorSchema: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        standardize: utils_1.convertListRegexpToArray,
        check: _a.checkFunctions.checkStringArray,
        validateValue: utils_1.isArrayOfStringNotEmpty
    },
    /**
     * Сравниваем `строка текста` с `возможно /регуляркой/`
     */
    [shared_types_1.EConditionsTags.text]: {
        tag: shared_types_1.EConditionsTags.text,
        path: 'payload.text',
        fastestValidatorSchema: {
            type: 'string'
        },
        check: _a.checkFunctions.checkString,
        validateValue: utils_1.isStringNotEmpty
    },
    /**
     * Сравниваем `+79999999999` с `/79{11}/`
     */
    [shared_types_1.EConditionsTags.recipient]: {
        tag: shared_types_1.EConditionsTags.recipient,
        path: 'payload.recipient',
        fastestValidatorSchema: {
            type: 'string'
        },
        check: _a.checkFunctions.checkString,
        validateValue: utils_1.isStringNotEmpty
    },
    /**
     * Сравниваем { mcc: '250', mnc: '01' } с { mcc: '250', mnc: '01' }[]
     */
    [shared_types_1.EConditionsTags.mccmnc]: {
        tag: shared_types_1.EConditionsTags.mccmnc,
        path: 'meta._recipientData',
        fastestValidatorSchema: {
            type: 'custom',
            messages: {
                // Register our new error message text
                notObject: 'mccmnc must be a plain object!',
                invalidMCC: 'mcc must be a three-digit value! Actual: {actual}',
                invalidMNC: 'mnc must be a string \'all\' or an array of 2-4 digit strings!'
            },
            // Здесь this - это инстанс класса FastestValidator
            check(value) {
                if (typeof value !== 'object' || !value) {
                    return this.makeError('notObject');
                }
                for (const mcc in value) {
                    if (!/^\d{3}$/.test(mcc)) {
                        return this.makeError('invalidMCC', 'three-digit', mcc);
                    }
                    const mnc = value[mcc];
                    if (mnc !== 'all' && (!Array.isArray(mnc) || mnc.some(v => typeof v !== 'string' || !/^\d{2,4}$/.test(v)))) {
                        return this.makeError('invalidMNC', 'all or 2-4 digits', mnc);
                    }
                }
                return true;
            }
        },
        check: (targetValue, value) => {
            let isValid = false;
            for (const mcc in value) {
                if (mcc === targetValue.mcc) {
                    if (value[mcc] === 'all') {
                        isValid = true;
                        break;
                    }
                    for (const mnc of value[mcc]) {
                        if (targetValue.mnc === mnc || targetValue.mnc === 'all') {
                            isValid = true;
                            break;
                        }
                    }
                    break;
                }
            }
            return isValid;
        },
        validateValue(value) {
            return !!(typeof value === 'object' && value &&
                typeof value.mcc === 'string' && value.mcc &&
                typeof value.mnc === 'string' && value.mnc);
        }
    },
    /**
     * Ищем '+79999999999` по списку ID[]
     */
    [shared_types_1.EConditionsTags.contactList]: {
        tag: shared_types_1.EConditionsTags.contactList,
        path: 'payload.recipient',
        fastestValidatorSchema: {
            type: 'array',
            items: {
                type: 'uuid'
            }
        },
        check: (targetValue, value) => __awaiter(void 0, void 0, void 0, function* () {
            return !value.length || (yield _a.checkFunctions.checkInContactLists(targetValue, value));
        }),
        validateValue: utils_1.isArrayOfUUID
    },
    /**
     * Проверяем `текст сообщения` на ID[] -> RegExp[][]
     */
    [shared_types_1.EConditionsTags.keywords]: {
        tag: shared_types_1.EConditionsTags.keywords,
        path: 'payload.text',
        fastestValidatorSchema: {
            type: 'array',
            items: {
                type: 'uuid'
            }
        },
        check: (targetValue, value) => __awaiter(void 0, void 0, void 0, function* () {
            return !value.length || (yield _a.checkFunctions.checkInKeywordLists(targetValue, value));
        }),
        validateValue: utils_1.isArrayOfUUID
    }
};
Conditions.backwardsCompatibilityTags = {
    // TODO: Удалить когда поменяем все пути в базе.
    'payload.text': _a.tags.text,
    'payload.type': _a.tags.type,
    'payload.sender': _a.tags.sender,
    'payload.recipient': _a.tags.recipient,
    'meta._recipientData.group': _a.tags.group,
    'meta._recipientData': _a.tags.mccmnc
};
Conditions.allTags = Object.assign(Object.assign({}, _a.tags), _a.backwardsCompatibilityTags);
/**
 * Эта функция добавлена сюда, чтобы до неё было достаточно легко добраться снаружи в случае необходимости (Actions.js)
 */
Conditions.generateRegExpFromString = utils_1.generateRegExpFromString;
/**
 * @deprecated Используйте checkMultipleConditions
 */
Conditions.asyncCheckConditions = _a.checkMultipleConditions.bind(_a);
//# sourceMappingURL=conditions.class.js.map